"use strict";

module.exports = require("./is-implemented")() ? Object.keys : require("./shim");



//////////////////
// WEBPACK FOOTER
// /Users/Fuunnx/workspace/zygmund/~/es5-ext/object/keys/index.js
// module id = ../../../node_modules/es5-ext/object/keys/index.js
// module chunks = 1